// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LTtmD","tabsBox":"styles_tabsBox__1J-2M","createButton":"styles_createButton__3b5xw"};